import React from 'react';
import styled from 'styled-components';

const IconContainer = styled.div`
  color: ${props => props.theme.colors.blue_v1};
  font-size: 20px;
  padding-right: 5px;
`;

export default IconContainer;
